import { CSSProperties, useMemo } from 'react';
import { Box } from '../Box';

interface IProps {
  lineClamp: number;
  text: string;
  style?: CSSProperties;
}

export const LineClamp = ({ lineClamp, text, style }: IProps) => {
  const fmtText = useMemo(() => {
    const div = document.createElement('div');

    if ('webkitLineClamp' in div.style) {
      return text;
    }

    const maxChars = lineClamp * 25;

    return text.length > maxChars ? text.slice(0, maxChars) + '…' : text;
  }, [text, lineClamp]);

  return (
    <Box
      style={{
        display: '-webkit-box',
        maxHeight: 1.4 * lineClamp + 'em',
        overflow: 'hidden',
        position: 'relative',
        textOverflow: 'ellipsis',
        width: '100%',
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: 'vertical',
        ...style,
      }}
    >
      {fmtText}
    </Box>
  );
};
